export default __webpack_public_path__ + "static/media/Raider's Straps of a Hundred Eyes.df94cc80.jpg";